/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Failed_DescriptionInputs */

const en_doc_failed_description = /** @type {(inputs: Doc_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI could not classify this file. You can continue and review it manually.`)
};

const pt_br2_doc_failed_description = /** @type {(inputs: Doc_Failed_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA não conseguiu classificar este arquivo. Você pode continuar e revisá-lo manualmente.`)
};

/**
* | output |
* | --- |
* | "The AI could not classify this file. You can continue and review it manually." |
*
* @param {Doc_Failed_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_failed_description = /** @type {((inputs?: Doc_Failed_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Failed_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_failed_description(inputs)
	return pt_br2_doc_failed_description(inputs)
});